module.exports = __webpack_public_path__ + "static/media/puff.b61fecc3.svg";